import container from '../container';

function notificationsManager() {
  const _notifications = [];

  return {
    execute(command, ...args) {
      return command.execute(_notifications, ...args);
    },
  };
}

const _notificationsManager = notificationsManager();

async function getNotifications(userId, userIsAParent) {
  try {
    return _notificationsManager.execute(
      container.queriesController.getNotificationsQuery({ userId, userIsAParent }),
    );
  } catch (error) {
    throw new Error('[Error]: get notifications request failed');
  }
}

async function marksAsReadNotification({ notificationId, date }) {
  try {
    return _notificationsManager.execute(
      container.commandsController.markAsReadNotification(notificationId, date),
    );
  } catch (error) {
    throw new Error('Ups!, we cant mark the notification as readed');
  }
}

async function markAllNotificationAsRead({ childId }) {
  try {
    return _notificationsManager.execute(
      container.commandsController.markAllNotificationAsRead(childId),
    );
  } catch (error) {
    throw new Error('Ups!, we cant mark all notifications as read');
  }
}

/**
 *  @TODO
 *  @description: Move method to coin module.
 * */
async function acceptOrRejectItem({ id, isAccept }) {
  try {
    return await _notificationsManager.execute(
      container.commandsController.acceptOrRejectItem({ id, isAccept }),
    );
  } catch (error) {
    throw new Error(
      '[Notifications]: Oops, sorry, we are having trouble accepting or declining the item, please try again later.',
    );
  }
}

export { getNotifications, marksAsReadNotification, markAllNotificationAsRead, acceptOrRejectItem };
